// DS: i2.3
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Reports: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path d="M5.253 7.547c0 .39.32.705.712.705h4.068a.71.71 0 0 0 .712-.705.71.71 0 0 0-.712-.705H5.965a.71.71 0 0 0-.712.705M5.965 9.662a.71.71 0 0 0-.712.705c0 .39.32.705.712.705h4.068a.71.71 0 0 0 .712-.705.71.71 0 0 0-.712-.705z"></path>
        <path
          fillRule="evenodd"
          d="M5.965 1c-.562 0-1.017.45-1.017 1.007v1.108H2.915A.91.91 0 0 0 2 4.021v10.073c0 .5.41.906.915.906h10.17a.91.91 0 0 0 .915-.906V4.02a.91.91 0 0 0-.915-.906h-2.036V2.007c0-.556-.455-1.007-1.017-1.007zM3.83 13.187V4.928h8.339v8.259z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
Reports.displayName = 'Reports';

export default Reports;
